import { createContext } from "react";

export const InvestPaymentContext = createContext();

